import React, { useState } from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
  Card,
  CardContent,
  Divider,
  useTheme,
  IconButton,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Select,
  MenuItem,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  DialogActions,
} from "@mui/material";
import ChangeLimitsModal from "./ChangeLimitsModal";

import CreditCardIcon from "@mui/icons-material/CreditCard";
import HistoryIcon from "@mui/icons-material/History";
import LockIcon from "@mui/icons-material/Lock";
import ListAltIcon from "@mui/icons-material/ListAlt";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import WifiIcon from "@mui/icons-material/Wifi";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import Chart from "react-apexcharts";
import { Stack } from "@mui/system";
import DashboardHeader from "../Dashboard/DashboardHeader";
import ChangePinPopup from "./ChangePinPopup";
import axios from "axios";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { baseapi } from "../Environmentalurl";
import {
  ApplicationType,
  date,
  entity_id,
  faq,
  getGeolocation,
  location,
  locationGeo,
  Platform,
} from "../Utils/Const";
import ForgotRuPayPinDialog from "./ForgotRuPayPinDialog";
import BlockCardDialog from "./BlockCardDialog";
import { useNavigate } from "react-router-dom";
import { Chip } from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import ApplyPhysicalcard from "./ApplyPhysicalcard";
import useIPAddress from "../Utils/useIPAddress";
import api from "../Utils/Api";

export default function Rupayhomefirstrow({ open, onClose, onSubmit }) {
  const [openPinPopup, setOpenPinPopup] = useState(false);
  const [openForgotPinPopup, setOpenForgotPinPopup] = useState(false);
  const [OpenBlockCard, setOpenBloackCard] = useState(false);
  const [showPin, setShowPin] = useState(false);
  const [showCardDetails, setShowCardDetails] = useState(false);
  const [fullCard, setFullCard] = useState("");
  const [expiry, setExpiry] = useState("");
  const [cvv, setCvv] = useState("");
  const [openTxnLimit, setOpenTxnLimit] = useState(false);
  const [encKey, setEncKey] = useState("");
  const [hexXor, setHexXor] = useState("");
  const [encryptedRpin, setEncryptedRpin] = useState("");
  const [encCardNumber, setEncCardNumber] = useState("");
  const [expDate, setExpDate] = useState("");
  const [cvvNumber, setCvvNumber] = useState("");
  const [openRpinDialog, setOpenRpinDialog] = useState(false);
  const [openComingSoon, setOpenComingSoon] = useState(false);
  const [enteredRpin, setEnteredRpin] = useState("");
  const [openErrorPopup, setOpenErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("ALL");
  const [txnData, setTxnData] = useState([]);
  const [page, setPage] = useState(1);
  const rowsPerPage = 5;
  const [rpin, setRpin] = useState("");
  const [timer, setTimer] = useState(0);
  const [openTpinDialog, setOpenTpinDialog] = useState(false);
  const [tpin, setTpin] = useState("");
  const [openKycPopup, setOpenKycPopup] = useState(false);
  const [tpinOpen, setTpinOpen] = useState(false);
   const ip = useIPAddress();

  const [isKycDone, setIsKycDone] = useState(
    sessionStorage.getItem("Is_KYC_Done") || "2",
  );

  const downloadExcel = () => {
    const data = filteredTxnData.map((row) => ({
      "Order ID": row.OrderID,
      Mobile: row.MobileNumber,
      Amount: row.Amount,
      Status: row.TrxnStatus,
      Narration: row.Narration,
      Date: new Date(row.InsertDatetime).toLocaleString(),
      Category: row.Category,
    }));

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Transactions");

    XLSX.writeFile(workbook, "transactions.xlsx");
  };

  const downloadPDF = () => {
    const doc = new jsPDF();

    doc.text("Transaction History", 14, 15);

    doc.autoTable({
      startY: 20,
      head: [
        [
          "Order ID",
          "Mobile",
          "Amount",
          "Status",
          "Narration",
          "Date",
          "Category",
        ],
      ],
      body: filteredTxnData.map((row) => [
        row.OrderID,
        row.MobileNumber,
        `₹${row.Amount}`,
        row.TrxnStatus,
        row.Narration,
        new Date(row.InsertDatetime).toLocaleString(),
        row.Category,
      ]),
      styles: { fontSize: 8 },
      headStyles: { fillColor: [77, 182, 77] }, // green header
    });

    doc.save("transactions.pdf");
  };

  const getDefaultFromDate = () => {
    const d = new Date();
    d.setMonth(d.getMonth() - 1); // ✅ last 1 month
    return d.toISOString().slice(0, 10); // yyyy-mm-dd
  };

  const getDefaultToDate = () => date;

  const [fromTxnDate, setFromTxnDate] = useState(getDefaultFromDate());
  const [toTxnDate, setToTxnDate] = useState(getDefaultToDate());

  useEffect(() => {
    if (isKycDone === "2") {
      setOpenKycPopup(true);
    }
  }, [isKycDone]);

  let timerInterval = null;

  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const navigate = useNavigate();

  // Apex Chart Config
  const chartOptions = {
    chart: {
      type: "bar",
      toolbar: { show: false },
      fontFamily: "Inter, sans-serif",
      offsetY: -50,
    },
    grid: {
      borderColor: "#eee",
      strokeDashArray: 4,
      padding: {
        top: -20, // 🔥 Removes extra top padding
      },
    },
    xaxis: {
      categories: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      labels: { style: { colors: "#777", fontSize: "12px" } },
    },
    yaxis: {
      labels: { style: { colors: "#777", fontSize: "12px" } },
    },
    plotOptions: { bar: { borderRadius: 8, columnWidth: "45%" } },
    colors: [
      "#1E1E1E",
      "#1E1E1E",
      "#1E1E1E",
      "#1E1E1E",
      "#4ADE80", // Highlight Friday
      "#1E1E1E",
      "#1E1E1E",
    ],
    grid: { borderColor: "#eee", strokeDashArray: 4 },
    dataLabels: { enabled: false },
    states: {
      hover: { filter: { type: "lighten", value: 0.15 } },
    },
  };

  const chartSeries = [
    { name: "Spending", data: [150, 220, 180, 260, 400, 230, 280] },
  ];

  const getCurrentDateTime = () =>
    date;

  const normalizeStatus = (s = "") => s.toUpperCase();
  const formatDateForApi = (value) => {
    if (!value) return "";
    const d = new Date(value);
    return d.toISOString().slice(0, 19).replace("T", " ");
  };

  // Recent transactions
  const fetchRupayTransactions = async () => {
    try {
      const payload = {
        ReqType: "Jan_Aadhaar_eWallet_Get_Rupay_Payment_Details_Report",
        Mobilenumber: JSON.parse(sessionStorage.getItem("mobileNumber")),
        Platform,
        ApplicationType,
        EntityID: entity_id,
        GeoLocation: locationGeo,
        MachineID: ip,
        SessionID: JSON.parse(sessionStorage.getItem("SessionID")),
        Date: getCurrentDateTime(),
      };

      if (fromTxnDate) payload.From_Date = formatDateForApi(fromTxnDate);
      if (toTxnDate) payload.To_Date = formatDateForApi(toTxnDate);
      const res = await api.post(
        `${baseapi}/EWalletGetRupayPaymentDetailsReport`,
        payload,
      );

      if (res?.data?.Response_Code === "2052" && res.data.Info) {
        setCategories(res.data.Info.Table || []);
        setTxnData(res.data.Info.Table1 || []);
      } else {
        setCategories([]);
        setTxnData([]);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchRupayTransactions();
    setPage(1); // reset pagination
  }, [fromTxnDate, toTxnDate]);

  const filteredTxnData =
    selectedCategory === "ALL"
      ? txnData
      : txnData.filter((t) => t.Category === selectedCategory);

  const paginatedData = filteredTxnData.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage,
  );

  const totalPages = Math.ceil(filteredTxnData.length / rowsPerPage);

  const topButtons = [
    {
      icon: <CreditCardIcon />,
      label: "Transaction Limit",
      onClick: () => setOpenTxnLimit(true),
    },
    {
      icon: <VpnKeyIcon />,
      label: "Change PIN",
      onClick: () => setOpenPinPopup(true),
    },
    {
      icon: <VpnKeyIcon />,
      label: "Forgot PIN",
      onClick: () => setOpenForgotPinPopup(true),
    },
    {
      icon: <LockIcon />,
      label: "Card Block / Unblock",
      onClick: () => setOpenBloackCard(true),
    },
    // { icon: <HistoryIcon />, label: "Transaction History" },
    {
      icon: <ListAltIcon />,
      label: "Apply Physical Card",
      onClick: () => {
        if (isKycDone === "2") {
          setOpenKycPopup(true); // 🔒 KYC BLOCK
          return;
        }
        setOpenTpinDialog(true); // ✅ Allowed
      },
    },

    {
      icon: <HelpOutlineIcon />,
      label: "FAQ",
      onClick: () => window.open(faq),
    },
  ];

  const rupayRefNo = useSelector((state) => state.auth.rupayRefNo);
  console.log("rupayRefNo" + rupayRefNo);

  const [maskedCard, setMaskedCard] = useState("");

  const Mobilenumber = JSON.parse(
    sessionStorage.getItem("mobileNumber") || "null",
  );
  const SessionID = JSON.parse(sessionStorage.getItem("SessionID") || "null");
  const name = JSON.parse(sessionStorage.getItem("NameOnCard") || "null");

  useEffect(() => {
    if (!rupayRefNo) return;

    const payload = {
      ReqType: "Jan_Aadhaar_eWallet_GetCardStatus",
      Mobilenumber: Mobilenumber,
      ReferenceNumber: rupayRefNo,
      Platform: Platform,
      ApplicationType: ApplicationType,
      EntityID: entity_id,
      GeoLocation: locationGeo,
      MachineID: ip,
      SessionID: SessionID,
    };

    api
      .post(`${baseapi}/getcardstatus`, payload)
      .then((res) => {
        if (res.data.Response_Code === "4001") {
          setMaskedCard(res.data.MaskedCard);
        }
      })
      .catch((err) => console.log(err));
  }, [rupayRefNo]);

  const formatMaskedCard = (card) => {
    if (!card || card.length < 8) {
      return "●●●● ●●●● ●●●● ●●●●";
    }

    const last4 = card.slice(-4);

    return `●●●● ●●●● ●●●● ${last4}`;
  };

  const handleShowCard = async (rpinValue) => {
    setEnteredRpin(rpinValue);
    setOpenRpinDialog(false);

    try {
      // STEP 1 → GET CARD STATUS
      const payload1 = {
        ReqType: "Jan_Aadhaar_eWallet_GetCardStatus",
        Mobilenumber: Mobilenumber,
        ReferenceNumber: rupayRefNo,
        Platform: Platform,
        ApplicationType: ApplicationType,
        EntityID: entity_id,
        GeoLocation: locationGeo,
        MachineID: ip,
        SessionID: SessionID,
      };

      const res1 = await api.post(`${baseapi}/getcardstatus`, payload1);
      setMaskedCard(res1.data.MaskedCard);
      setEncKey(res1.data.EncKey);

      // STEP 2 → hexXorgenerator
      const res2 = await api.post(`${baseapi}/hexXorgenerator`, {
        rpin: rpinValue,
        mobilenumber: Mobilenumber,
      });
      setHexXor(res2.data); // example: 0412A77EBE7D8B00

      // STEP 3 → ewalletRupayEncryption3DES
      const payload3 = {
        ReqType: "Jan_Aadhaar_eWallet_RupayEncryption3DES",
        Mobilenumber: Mobilenumber,
        Enc_Key: res1.data.EncKey,
        Date: date,
        Hex_XOR_Value: res2.data,
        Platform,
        SessionID,
        ApplicationType,
        EntityID: entity_id,
        GeoLocation: locationGeo,
        MachineID: ip,
      };

      const res3 = await api.post(
        `${baseapi}/ewalletRupayEncryption3DES`,
        payload3,
      );
      setEncryptedRpin(res3.data.RPIN);

      // STEP 4 → ViewOriginalCard
      const payload4 = {
        ReqType: "Jan_Aadhaar_eWallet_ViewOriginalCard",
        Mobilenumber: Mobilenumber,
        ReferenceNumber: rupayRefNo,
        R_PIN: res3.data.RPIN,
        CardNumber: res1.data.MaskedCard,
        Platform,
        ApplicationType,
        EntityID: entity_id,
        GeoLocation: locationGeo,
        SessionID,
        MachineID: ip,
      };

      const res4 = await api.post(`${baseapi}/ViewOriginalCard`, payload4);

      // ❌ Invalid PIN (or any non-success) → show error popup
      if (res4.data.Response_Code !== "1000") {
        setErrorMessage(
          res4.data.Message || "Invalid PIN. Please try again.",
        );
        setOpenErrorPopup(true);
        setShowCardDetails(false);
        setRpin("");
        return;
      }

      setEncCardNumber(res4.data.EncCardNumber);
      setCvvNumber(res4.data.CVV);

      const raw = res4.data.ExpDate;
      setExpDate(`${raw.substring(0, 2)}/${raw.substring(2)}`);

      setShowCardDetails(true);

      setTimer(30);

      timerInterval = setInterval(() => {
        setTimer((prev) => {
          if (prev <= 1) {
            clearInterval(timerInterval);
            setShowCardDetails(false);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    } catch (err) {
      console.log("Error:", err);
      setErrorMessage("Something went wrong. Please try again.");
      setOpenErrorPopup(true);
    }
  };

  {
  }

  const formatCardNumber = (cardNumber = "") => {
    if (!cardNumber) return "";

    // remove spaces just in case
    const digits = cardNumber.replace(/\s+/g, "");

    // group into 4-4-4-4
    return digits.replace(/(.{4})/g, "$1 ").trim();
  };

  return (
    <>
      <Grid container spacing={3} mb={3}>
        {/* LEFT SIDE */}
        <Grid size={{ xs: 12, md: 8 }} item xs={12} md={8}>
          {/* WALLET CARD */}
          <Grid container spacing={3} alignItems="stretch">
            {/* LEFT CARD - FIXED WIDTH */}
            <Grid size={{ xs: 12, md: 6 }} item xs={12} md={"auto"}>
              <Card
                sx={{
                  height: "100%",
                  background:
                    "linear-gradient(135deg, #6E2CF5, #3B1BF7 60%, #2C0FDB)",
                  borderRadius: 4,
                  color: "#fff",
                  p: 3,
                }}
              >
                <Box display={"flex"} justifyContent={"space-between"}>
                  <Box>
                    <Typography fontSize={18} sx={{ opacity: 0.9 }}>
                      TA Wallet
                    </Typography>
                    <Typography fontSize={13} sx={{ opacity: 0.9 }}>
                      Premium
                    </Typography>
                  </Box>
                  <Box mt={2}>
                    <img src="/Assets/wifi.png" height={40} />
                  </Box>
                </Box>

                <img
                  src="/Assets/chipimg.png"
                  height={30}
                  style={{ marginTop: "10px" }}
                />

                <Box sx={{ position: "relative", mt: 2 }}>
                  <Typography fontSize={18} letterSpacing={2}>
                    {showCardDetails
                      ? formatCardNumber(encCardNumber)
                      : formatMaskedCard(maskedCard)}
                  </Typography>

                  <Typography
                    sx={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      fontSize: "12px",
                      color: "red",
                      opacity: showCardDetails ? 1 : 0,
                      transition: "opacity 0.3s",
                    }}
                  >
                    Auto-hiding in {timer} sec
                  </Typography>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    mt: 5,
                    opacity: 0.9,
                  }}
                >
                  <Box>
                    <Typography>Card Holder</Typography>
                    <Typography>{name}</Typography>
                  </Box>

                  <Box display={"flex"} justifyContent={"space-evenly"}>
                    <Box>
                      <Typography>Expires</Typography>
                      <Typography>
                        {showCardDetails ? expDate : "●●/●●"}
                      </Typography>
                    </Box>

                    <Box ml={2}>
                      <Typography>CVV</Typography>
                      <Typography>
                        {showCardDetails ? cvvNumber : "●●●"}
                      </Typography>
                    </Box>

                    <Box ml={1}>
                      <IconButton
                        onClick={() => {
                          clearInterval(timerInterval); // stop old timers
                          setTimer(0); // reset timer
                          setRpin("");
                          setOpenRpinDialog(true);
                        }}
                      >
                        <RemoveRedEyeIcon sx={{ color: "white" }} />
                      </IconButton>
                    </Box>
                  </Box>
                  <Dialog
                    open={openRpinDialog}
                    onClose={() => {
                      setRpin("");
                      setOpenRpinDialog(false);
                    }}
                    PaperProps={{
                      sx: {
                        borderRadius: 3,
                        width: 360,
                        p: 1,
                      },
                    }}
                  >
                    {/* TITLE */}
                    <DialogTitle
                      sx={{
                        textAlign: "center",
                        fontWeight: 600,
                        fontSize: 18,
                        pb: 0,
                      }}
                    >
                      Secure Verification
                    </DialogTitle>

                    <Typography
                      sx={{
                        textAlign: "center",
                        fontSize: 13,
                        color: "text.secondary",
                        mb: 2,
                      }}
                    >
                      Enter your 4-digit RPIN to view card details
                    </Typography>

                    {/* CONTENT */}
                    <DialogContent>
                      <TextField
                        fullWidth
                        autoFocus
                        type="password"
                        value={rpin}
                        onChange={(e) =>
                          setRpin(e.target.value.replace(/\D/g, ""))
                        }
                        inputProps={{
                          maxLength: 4,
                          inputMode: "numeric",
                          style: {
                            textAlign: "center",
                            letterSpacing: "6px",
                            fontSize: "20px",
                            fontWeight: 600,
                          },
                        }}
                        placeholder="● ● ● ●"
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: 2,
                            height: 52,
                          },
                        }}
                      />

                      {/* ACTIONS */}
                      <Box mt={3} display="flex" gap={2}>
                        <Button
                          variant="outlined"
                          fullWidth
                          onClick={() => {
                            setRpin("");
                            setOpenRpinDialog(false);
                          }}
                          sx={{
                            borderRadius: 2,
                            textTransform: "none",
                          }}
                        >
                          Cancel
                        </Button>

                        <Button
                          variant="contained"
                          fullWidth
                          disabled={rpin.length !== 4}
                          onClick={() => handleShowCard(rpin)}
                          sx={{
                            borderRadius: 2,
                            textTransform: "none",
                            fontWeight: 600,
                            color: "white",
                          }}
                        >
                          Verify
                        </Button>
                      </Box>
                    </DialogContent>
                  </Dialog>
                </Box>
              </Card>
            </Grid>

            {/* RIGHT CARD - EXPANDS FULL WIDTH */}
            <Grid size={{ xs: 12, md: 6 }} item xs={12} md display="flex">
              <Box
                sx={{
                  borderRadius: 3,
                  bgcolor: isDark ? "#0B1C30" : "#f5f5f5",
                  border: isDark
                    ? "1px solid rgba(90, 126, 173, 0.49)"
                    : "1px solid rgba(0,0,0,0.2)",
                  p: 2.5,
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {/* HEADER */}
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="flex-start"
                >
                  <Box>
                    <Typography fontSize={16} fontWeight={700} mb={0.5}>
                      Financial Analytics
                    </Typography>
                    <Typography sx={{ color: "#888", fontSize: "13px" }}>
                      Track your daily spendings
                    </Typography>
                  </Box>

                  <Stack direction="row" spacing={0.5}>
                    {["Weekly", "Monthly", "Yearly"].map((t, i) => (
                      <Button
                        key={i}
                        variant={i === 0 ? "contained" : "outlined"}
                        sx={{
                          textTransform: "none",
                          fontSize: "10px",
                          px: 1.2,
                          py: 0.2,
                          borderRadius: "6px",
                          minWidth: "52px",
                          height: "22px",
                          bgcolor: i === 0 ? "#f3f4f6" : "transparent",
                          color: "#111",
                          borderColor: "#e5e7eb",
                        }}
                      >
                        {t}
                      </Button>
                    ))}
                  </Stack>
                </Box>

                {/* SPACE */}
                <Box mt={1} />

                {/* CONTENT */}
                <Grid
                  container
                  spacing={2}
                  sx={{ flexGrow: 1 }}
                  alignItems="center"
                >
                  {/* PIE CHART */}
                  <Grid
                    size={{ xs: 12, md: 6 }}
                    item
                    xs={12}
                    md={6}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Chart
                      type="donut"
                      height={180}
                      series={[1240, 850, 420, 300]}
                      options={{
                        labels: ["Shopping", "Dining", "Travel", "Bills"],
                        colors: ["#6366F1", "#22C55E", "#F59E0B", "#EF4444"],
                        legend: { show: false },
                        dataLabels: { enabled: false },
                        stroke: { width: 0 },
                        plotOptions: {
                          pie: {
                            donut: {
                              size: "70%",
                              labels: {
                                show: true,
                                total: {
                                  show: true,
                                  label: "Total",
                                  fontSize: "14px",
                                  color: "#888",
                                  formatter: () => "₹2,810",
                                },
                              },
                            },
                          },
                        },
                      }}
                    />
                  </Grid>

                  <Grid size={{ xs: 12, md: 6 }}>
                    <Box
                      sx={{
                        px: 1,
                      }}
                    >
                      {[
                        {
                          label: "Shopping",
                          amount: "₹1,240",
                          color: "#6366F1",
                        },
                        {
                          label: "Dining",
                          amount: "₹850",
                          color: "#22C55E",
                        },
                        {
                          label: "Travel",
                          amount: "₹420",
                          color: "#F59E0B",
                        },
                        {
                          label: "Bills",
                          amount: "₹300",
                          color: "#EF4444",
                        },
                      ].map((item, i) => (
                        <Box
                          key={i}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.7,
                            px: 1.2,
                            py: 0.6,
                            borderRadius: "8px",
                            backgroundColor: isDark ? "#0E2239" : "#f9fafb",
                            border: "1px solid rgba(0,0,0,0.08)",
                            minWidth: 95,
                            mr: 1,
                          }}
                        >
                          <Box
                            sx={{
                              width: 7,
                              height: 7,
                              borderRadius: "50%",
                              backgroundColor: item.color,
                            }}
                          />
                          <Typography fontSize={11} fontWeight={500}>
                            {item.label}
                          </Typography>
                          <Typography fontSize={11} fontWeight={600} ml="auto">
                            {item.amount}
                          </Typography>
                        </Box>
                      ))}
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Grid>
        {/* RIGHT SIDE */}
        <Grid size={{ xs: 12, md: 4 }} item xs={12} md={4}>
          <Card
            sx={{
              borderRadius: 4,
              p: 2.5,
              width: "100%",
              height: "100%",
              bgcolor: isDark ? "#0B1C30" : "#f5f5f5",
              border: isDark
                ? "1px solid rgba(90, 126, 173, 0.49)"
                : "1px solid rgba(0,0,0,0.2)",
            }}
          >
            {/* Header (unchanged) */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography fontWeight={600}>RuPay Offers</Typography>

              <Button
                sx={{ textTransform: "none" }}
                onClick={() =>
                  window.open(
                    "https://www.rupay.co.in/domestic-offers",
                    "_blank",
                    "noopener,noreferrer",
                  )
                }
              >
                Full Screen
              </Button>
            </Box>

            {/* Content area – EXACT same space */}
            <Box sx={{ mt: 2 }}>
              <iframe
                src="https://www.rupay.co.in/domestic-offers"
                title="RuPay Offers"
                style={{
                  width: "100%",
                  height: "27vh",
                  border: "none",
                }}
              />
            </Box>
          </Card>
        </Grid>
      </Grid>

      {/* ================= INVALID PIN / ERROR POPUP ================= */}
      <Dialog
        open={openErrorPopup}
        onClose={() => setOpenErrorPopup(false)}
        PaperProps={{
          sx: {
            borderRadius: 4,
            width: 360,
            boxShadow: "0px 20px 60px rgba(0,0,0,0.25)",
          },
        }}
      >
        <DialogContent sx={{ textAlign: "center", p: 4 }}>
          {/* ICON BADGE */}
          <Box
            sx={{
              width: 80,
              height: 80,
              borderRadius: "50%",
              mx: "auto",
              mb: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "linear-gradient(135deg, #ef4444, #dc2626)",
            }}
          >
            <ErrorOutlineIcon sx={{ fontSize: 44, color: "#fff" }} />
          </Box>

          <Typography fontSize={20} fontWeight={700} sx={{ color: "#111827" }}>
            Invalid PIN
          </Typography>

          <Typography
            fontSize={14}
            mt={1}
            sx={{ color: "#6b7280", lineHeight: 1.6 }}
          >
            {errorMessage}
          </Typography>

          <Button
            variant="contained"
            onClick={() => setOpenErrorPopup(false)}
            sx={{
              mt: 3,
              px: 4,
              py: 1.2,
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 600,
              backgroundColor: "#dc2626",
              "&:hover": { backgroundColor: "#b91c1c" },
            }}
          >
            Try Again
          </Button>
        </DialogContent>
      </Dialog>
    </>
  );
}